import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const reducers = {
  AddBreadcrum: (state, action) => {
    return [...state, action.payload];
  },
  AddNewBreadcrum: (state, action) => {
    return [...action.payload];
  },
  RemoveBreadcrum: (state, action) => {
    return [...action.payload];
  },
};

const breadCrumSlice = createSlice({
  initialState,
  name: "breadCrum",
  reducers,
});

export const { AddBreadcrum, RemoveBreadcrum, AddNewBreadcrum } =
  breadCrumSlice.actions;

export default breadCrumSlice;
